import { makeStyles } from '@material-ui/core/styles'
import { deepOrange } from '@material-ui/core/colors'

export const useStyles = makeStyles((theme) => ({
  infobox: {
    margin: theme.spacing(2),
    color: '#fff',
    display: 'flex',
    boxShadow:
      'rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px',

    borderRadius: 6,
  },
  infoboxIconContainer: {
    padding: theme.spacing(4),
    display: 'flex',
    backgroundColor: 'rgba(0, 0, 0, .2)',
    // borderRadius: 6,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
  },
  infoboxIcon: {
    fontSize: 38,
    color: 'rgba(255, 255, 255, .5)',
  },
  infoboxContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  divList: {
    display: 'row',
    alignItems: 'center',
    justifyContent: 'right',
    marginLeft: 23,
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: 'inline',
  },
  small: {
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  square: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  },
}))
